import { render, staticRenderFns } from "./AzEditor.vue?vue&type=template&id=0b9acd8b&"
import script from "./AzEditor.vue?vue&type=script&lang=js&"
export * from "./AzEditor.vue?vue&type=script&lang=js&"
import style0 from "./AzEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports